export const CrashSoundsName = {
  win: 'win',
  timer: 'timer',
  bet: 'bet',
};

export const CrashSoundsPath = [
  {
    src: 'audio/crash/win.mp3',
    name: CrashSoundsName.win,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/crash/timer.mp3',
    name: CrashSoundsName.timer,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/crash/bet.mp3',
    name: CrashSoundsName.bet,
    autoplay: false,
    html5: true,
  },
];
